import * as React from 'react';
import type { SVGProps } from 'react';
const SubscriberIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.5299 16.772C12.3022 17.2315 11.7452 17.4194 11.2857 17.1918C10.8263 16.9641 10.6384 16.4071 10.866 15.9476"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.4642 15.1918C14.3634 15.1419 14.3222 15.0197 14.3721 14.9188L15.6198 11.6968C16.2251 10.1338 15.5385 8.36723 14.0367 7.62307C12.5349 6.87892 10.7134 7.40282 9.83648 8.83113L8.02863 11.7756C7.97866 11.8765 7.85647 11.9177 7.75564 11.8677C7.39126 11.6872 6.94949 11.8362 6.76893 12.2006L6.66015 12.4201C6.47959 12.7845 6.62864 13.2262 6.99302 13.4068L13.7016 16.7309C14.066 16.9114 14.5077 16.7624 14.6883 16.3981L14.7971 16.1785C14.9776 15.8142 14.8286 15.3724 14.4642 15.1918Z"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.1992 7.23068C14.9865 7.66002 14.466 7.83561 14.0367 7.62285C13.6073 7.41014 13.4317 6.88962 13.6445 6.46032C13.8572 6.03098 14.3777 5.85539 14.8071 6.06811C15.2364 6.28086 15.4119 6.80134 15.1992 7.23068Z"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.7963 10.1349C19.9362 6.05941 16.3156 2.99997 11.979 2.99997C7.64247 2.99997 4.02183 6.05941 3.1618 10.1349"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.03186 13.0762C3.56444 17.5393 7.36677 21 11.979 21C16.5912 21 20.3934 17.5393 20.9261 13.0762"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2 14.9501L3.03186 13.0763L4.90802 14.1069"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.8317 9.28901L20.7983 10.1349L21.6452 8.17078"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SubscriberIcon;
